import { render, staticRenderFns } from "./BookingVisitedCancel.vue?vue&type=template&id=6ec7d4a4"
import script from "./BookingVisitedCancel.vue?vue&type=script&lang=js"
export * from "./BookingVisitedCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports